// @ts-nocheck

import React, { PureComponent } from 'react';

import { Box } from '@mui/material';
import { BrowserRouter } from 'react-router-dom';
import { createGenerateClassName, StylesProvider } from '@mui/styles';
import { Loader, ThemeProvider as ThemeProviderX5 } from '@x5-react-uikit/core';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import { ToastContainer } from 'react-toastify';
import 'moment/locale/ru';

import { ErrorBoundary } from 'containers/ErrorBoundary';
import { user } from 'apis';
import createStore from 'store';
import Layout from '../Layout';
import Router from './Router';

import muiTheme from 'theme/muiTheme';
import 'react-toastify/dist/ReactToastify.css?global';

const generateClassName = createGenerateClassName({
  productionPrefix: 'jss-',
});

export default class App extends PureComponent {
  state = { error: null, user: null };

  private fetch = async () => {
    try {
      // To not trigger infinite amount of redirects from "/login" to "/login" page.
      // Request user without authorization check
      return await user.guestMe();
    } catch (e) {
      console.error(e);
      if ([401, 500].includes(e?.status)) {
        return {};
      }

      window.location.replace('/api/oauth2/authorization/keycloak');

      return null;
    }
  };

  async componentDidMount() {
    try {
      const user = await this.fetch();
      this.setState({ user });
    } catch (error) {
      this.setState({ error });
    }
  }

  componentDidUpdate() {
    if (this.state.error !== null) {
      throw this.state.error;
    }
  }

  render() {
    const { user } = this.state;

    if (!user) {
      return (
        <Box display="flex" height="100vh" justifyContent="center">
          <Loader />
        </Box>
      );
    }

    return (
      <ErrorBoundary>
        <ThemeProvider theme={muiTheme}>
          <ThemeProviderX5>
            <StylesProvider generateClassName={generateClassName}>
              <ToastContainer closeButton={false} />
              <Provider store={createStore(user)}>
                <BrowserRouter>
                  <Layout>
                    <Router user={user} />
                  </Layout>
                </BrowserRouter>
              </Provider>
            </StylesProvider>
          </ThemeProviderX5>
        </ThemeProvider>
      </ErrorBoundary>
    );
  }
}
